import { render, staticRenderFns } from "./input-file-item.vue?vue&type=template&id=8d02bc80&"
import script from "./input-file-item.vue?vue&type=script&lang=js&"
export * from "./input-file-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports